import styles from "./skills.module.scss";

const groups = [
    {
        title: "Frontend",
        items: ["React", "Next.js", "Angular.js", "TypeScript", "JavaScript", "HTML5", "Sass"],
    },
    {
        title: "Interface",
        items: ["Design System", "Figma", "Styled Components", "Tailwind", "Acessibilidade"],
    },
    // {
    //     title: "Backend",
    //     items: ["Node.js", "Express", "REST API", "PostgreSQL", "Prisma"],
    // },
    // {
    //     title: "Ferramentas",
    //     items: ["Git", "Docker", "Vite", "Jest", "CI/CD"],
    // },
];

export const Skills = () => {
    return (
        <section id="skills" className={styles["container"]}>
            <div className={styles["inner"]}>
                <div className={styles["head"]}>
                    <div className={styles["head-text"]}>
                        <span className={styles["label"]}>02 — Skills</span>
                        <h2 className={styles["title"]}>
                            Tecnologias que uso no dia a dia
                        </h2>
                    </div>
                    <p className={styles["description"]}>
                        Trabalho principalmente no ecossistema React com TypeScript,
                        mas circulo bem por toda a stack. Prefiro ferramentas simples,
                        bem documentadas e que deixem o time produtivo sem abrir mão
                        de qualidade.
                    </p>
                </div>

                <div className={styles["grid"]}>
                    {groups.map((group) => (
                        <article key={group.title} className={styles["group"]}>
                            <h3 className={styles["group-title"]}>
                                <i className={styles["marker"]} />
                                {group.title}
                            </h3>
                            <ul className={styles["list"]}>
                                {group.items.map((item) => (
                                    <li key={item} className={styles["chip"]}>
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </article>
                    ))}
                </div>

                <div className={styles["marquee"]}>
                    <div className={styles["track"]}>
                        {[...groups, ...groups].map((group, index) =>
                            group.items.map((item) => (
                                <span key={`${item}-${index}`}>{item}</span>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Skills;
